/* @flow */

import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './FullscreenTemplate.style';
import TakeOverPortal from 'src/shared/app/notification/component/TakeOverPortal';
import NotificationPortal from 'src/shared/app/notification/component/NotificationPortal';
import Container from 'src/shared/app/base/component/container/Container';

const useStyles = createUseThemeStyles(styles);

type Props = {
  Switch: React.ComponentType<any>,
};

const WithFullscreenTemplate = ({ Switch }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <NotificationPortal />
      <TakeOverPortal />

      <div className={classes.main}>
        <Container>
          <Switch />
        </Container>
      </div>
    </div>
  );
};

export default React.memo<Props>(WithFullscreenTemplate);
